import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { history } from '$src/stores/history';
import { routes } from '$src/routes';
import useStores from '$src/hooks/useStores';
import useQuery from '$src/hooks/useQuery';
import { redirectToOnboardingIntroduction, redirectToURL } from '$src/utils/redirect';
import { ONBOARDING_DENIED_ACTION_ID } from '$src/constants/actions';

import Authorize from '../Onboarding/Authorize';

const OnBoard = () => {
  const [errorCode, setErrorCode] = useState();
  const {
    sessionStore: { fetchMe, user
    },
    statsStore: { sendStats },
  } = useStores();
  const searchParams = useQuery();
  const redirectLocation = JSON.parse(sessionStorage.getItem('referrer'));

  useEffect(() => {
    const sendPageViewEvent = () => {
      if (!user) {
        fetchMe(true);
      } else {
        sendStats(undefined, undefined, ONBOARDING_DENIED_ACTION_ID);
      }
    };

    if (searchParams.success) {
      if (redirectLocation) redirectToURL(redirectLocation);
      else history.push(redirectLocation || routes.locations);
    } else {
      setErrorCode(searchParams.error_code);
      sendPageViewEvent();
    }
  }, [fetchMe, user, sendStats, searchParams, redirectLocation 
  ]);

  if (!errorCode) {
    return null;
  }

  return <Authorize redirect={() => redirectToOnboardingIntroduction(searchParams.locationId)} />;
};

export default observer(OnBoard);
